import { ReactNode, useCallback, useEffect, useState } from 'react';
import axios, { AxiosError, AxiosResponse } from 'axios';

import { api } from '@hooks/useFetch';
import { usePlatformContext } from "@datassential/platform-ui-lib";

const AxiosInterceptor = ({ children }: { children: ReactNode }) => {
    const [isSet, setIsSet] = useState(false);
    const { userInfo: { snapUiUrl,  } } = usePlatformContext();

    const onResponse = useCallback(
        (response: AxiosResponse): AxiosResponse => {
            const status = response.status;

            if (status === 205) {
                window.location.reload();
            }

            return response;
        },
        [],
    );

    const onErrorResponse = useCallback(
        (error: AxiosError): Promise<AxiosError> => {
            if (axios.isAxiosError(error)) {
                const { status } = (error.response as AxiosResponse) ?? {};

                if (status === 401) {
                    window.location.href = `${process.env.REACT_APP_API}/userAuth?returnUrl=${window.location.href}`;
                }
                if (status === 403) {
                    window.location.href = snapUiUrl;
                }
            }
            return Promise.reject(error);
        },
        [snapUiUrl]
    );

    useEffect(
        () => {
            const responseInterceptor = api.interceptors.response.use(onResponse, onErrorResponse);
            setIsSet(true);

            return () => api.interceptors.response.eject(responseInterceptor);
        },
        [onResponse, onErrorResponse]
    );

    return <>{isSet && children}</>;
};

export default AxiosInterceptor;
